export var HEIGHT_OFF_SET = 50;